import { Node_Type } from "./../../ricos-types/index.js";
import Gallery from "./gallery.js";
const nodeViewRenderers = {
  [Node_Type.GALLERY]: Gallery
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers.js.map
